{
    "form-editor": {
        "nav": {
            "undo": "Undo ({{hotkey}})",
            "redo": "Redo ({{hotkey}})",
            "embed": "Embed ({{hotkey}})",
            "open-in-browser": "Open Form in Browser",
            "formVersionHistory": "Show Version History",
            "unpublishForm": "Make private",
            "publishForm": "Publish",
            "saveForm": "Save",
            "saveFormAs": "Save as…",
            "exportForm": "Export…",
            "importFormFile": "Import…",
            "renameForm": "Rename…",
            "deleteForm": "Delete…",
            "exportL10n": "Export Localization...",
            "importL10n": "Import Localization..."
        },
        "layout": {
            "title": "Layout",
            "description": "Drag and Drop Form Elements to create your desired structure",
            "edit": {
                "title": "Edit",
                "outline": "Outline",
                "components": "Components",
                "settings": "Settings"
            },
            "translate": {
                "title": "Translate",
                "outline": "Outline",
                "components": "Components",
                "settings": "Settings"
            },
            "preview": {
                "title": "Preview",
                "outline": "Outline",
                "scope": "Scope",
                "settings": "Settings"
            }
        },
        "datasources": {
            "title": "Datasources",
            "description": "Configure static data needed in your form.",
            "confirmDeleteCascade": "Elements will be affected by deleting this Datasource, do you want to continue?"
        },
        "workflow": {
            "title": "Workflow",
            "description": "Control the behaviour of your form.",
            "flow": "Flow",
            "settings": "Settings",
            "library": "Library",
            "formReadyNode": "On Start",
            "formSubmitNode": "On Submit",
            "nothingSelected": "Nothing selected"
        },
        "constants": {
            "title": "Constants",
            "description": "Configure constant values to be used anywhere in your form."
        },
        "saveFormAsDialog": {
            "title": "Save as",
            "successToast": "Saved",
            "namePlaceholder": "Name"
        },
        "renameFormDialog": {
            "title": "Rename",
            "namePlaceholder": "Name"
        },
        "deleteFormDialog": {
            "message": "Do you want to permanently Delete {{name}}?",
            "busyToast": "Deleting {{name}}…",
            "doneToast": "Deleted {{name}}…"
        },
        "formVersionHistoryDialog": {
            "title": "Version History"
        },
        "formVersionHistory": {
            "revert": "Revert to this version",
            "duplicate": "Create new project from this version"
        },
        "formEmbedDialog": {
            "title": "Embed"
        },
        "savePresetDialog": {
            "title": "Preset",
            "deleteButton": "Delete",
            "deleteMessage": "Are you sure yo want to delete this preset?",
            "confirmOverrideMessage": "A Preset with the name \"{{name}}\" already exists, are you sure you want to override it?"
        },
        "formPresetPreview": {
            "notRenderable": "Preset not previewable"
        },
        "hyperlinkEmbed": {
            "title": "Hyperlink",
            "description": "Simply link to the hosted form."
        },
        "inlineEmbed": {
            "title": "Inline Tag",
            "description": "Embed a form into a HTML document with a provided custom tag."
        },
        "previewSettings": {
            "authGroupTitle": "Authorization",
            "customLocals": "Custom Environment Variables",
            "customLocalsVariable": "Variable Name",
            "customLocalsValue": "Value"
        },
        "confirmMergeDialog": {
            "message": "A newer version of the form is available, do you want to apply the following changes?"
        }
    },
    "mask": {
        "BuilderFormMask": {
            "name": "Name (internal)",
            "published": "Published",
            "behaviourGroupTitle": "Behaviour",
            "showValidFeedback": "Show valid field Feedback",
            "customizationGroupTitle": "Customization",
            "includeCoreResources": "Include Core Resources",
            "includeBootstrapCdn": "Include Bootstrap CDN",
            "bootstrapCdnUrl": "Bootstrap CDN Resource",
            "resources": "Additional Resources",
            "resourcesUrl": "Url",
            "stylesheet": "Inline Stylesheet"
        },
        "BuilderInlineEmbedMask": {
            "description": "### Inline Embed\nPaste the script tag in places where you want to display your form.\nYou can pass variables to the form by adding a `data-session=\"{YOUR_JSON_OBJECT_LITERAL}\"` attribute or putting your json object literal into the body of the script tag.\n\rShould you want to authenticate from within a document where the `dodo` library is available, you can add the `data-identity-provider=\"dodo\"` attribute.\n\rShould you want to make the search parameters of the host document available in the form as variables, please add the `data-use-host-search-params` attribute to the script tag.\n\r",
            "code": "Embed Code"
        }
    },
    "elementControls": {
        "deleteElement": "Delete this Element",
        "copyElement": "Copy this Element",
        "cutElement": "Cut this Element",
        "pasteElement": "Paste after this Element",
        "savePreset": "Create or Update Preset from this Element"
    },
    "import-l10n": {
        "importing": "Importing…",
        "success": {
            "singular": "Import successful. One localization key updated.",
            "plural": "Import successful. {{count}} localization keys updated."
        },
        "unmatchedElementsMessage": {
            "singular": "One unmatched element was ignored.",
            "plural": "{{count}} unmatched elements were ignored."
        }
    }
}